import { DEFAULT_RAW_PER_PAGE_LOAD } from 'app/settings/defaultValues'
import {
  ComplianceListOptions,
  ComplianceSummary,
  ComplianceTableColumnsKeys
} from 'types/entity'

export const ColumnLabelConfig: Record<ComplianceTableColumnsKeys, string> = {
  member_name: 'Member name',
  program_name: 'Program',
  verification_status: 'Document compliance',
  vehicle_verification_status: 'Vehicle compliance',
  submission_date: 'Submission date',
  last_reviewed: 'Last reviewed date',
  reviewed_by: 'Reviewer email'
}

export const defaultColumns: ComplianceTableColumnsKeys[] = [
  'member_name',
  'program_name',
  'verification_status',
  'vehicle_verification_status'
]

export const defaultColumnOrder: ComplianceTableColumnsKeys[] = [
  'member_name',
  'program_name',
  'verification_status',
  'vehicle_verification_status',
  'submission_date',
  'last_reviewed',
  'reviewed_by'
]

export const getRejectionReasonsContent = (
  verification_errors: ComplianceSummary['verification_errors']
) => {
  const vehicleFields = [
    'vin',
    'allowed_depreciation_method',
    'msrp',
    'year',
    'make',
    'model'
  ]
  const vehicleFieldsReasons: string[] = []
  const documentFieldsReasons: string[] = []

  Object.entries(verification_errors).forEach(([key, value]) => {
    if (!value.errors.length && !value.default_error) return
    const reason = value.errors.length ? value.errors[0] : value.default_error
    if (vehicleFields.includes(key)) {
      vehicleFieldsReasons.push(reason)
    } else {
      documentFieldsReasons.push(reason)
    }
  })

  return {
    vehicleFieldsReasons,
    documentFieldsReasons
  }
}

export const getComplianceFilter = (
  urlParams: URLSearchParams
): ComplianceListOptions & { page?: number; page_size?: number } => ({
  vehicle_verification_status:
    urlParams.get('vehicle_verification_status') ?? '',
  verification_status: urlParams.get('verification_status') ?? '',
  email: urlParams.get('email') ?? '',
  q: urlParams.get('q') ?? '',
  program_token_id: urlParams.get('program_token_id') ?? '',
  submission_date: urlParams.get('submission_date') ?? '',
  review_date: urlParams.get('review_date') ?? '',
  team_token_id: urlParams.get('team_token_id') ?? '',

  page: urlParams.get('page') ? parseInt(String(urlParams.get('page'))) : 1,
  page_size: urlParams.get('page_size')
    ? parseInt(String(urlParams.get('page_size'))) > 100
      ? 100
      : parseInt(String(urlParams.get('page_size')))
    : DEFAULT_RAW_PER_PAGE_LOAD[0]
})

export const calculateComplianceIndex = (
  list_position: number,
  page: number,
  page_size: number
) => {
  if (page === 1) return list_position
  return list_position + (page - 1) * page_size
}
